import * as React from "react";

import { useContext } from "react";
import { Typography, useTheme, Divider } from "@mui/material";
import { AppContext } from "../../contextProviders/AppContext";
import { add } from "date-fns";
import DatePickerDateInput from "./DateInput";
import { translation } from "../Dictionary";
import { Box } from "@mui/system";
import { useRef } from "react";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
export default function DatePickerFixedDuration({
  contentHeigth,
  selectedPicker,
  setSelectedPicker,
}) {
  const {
    mobileViewPort,
    selectedDateRange,
    isDisabled,
    setSelectedDateRange,
  } = useContext(AppContext);
  const containerRef = useRef();
  //
  const [anchorEl, setAnchorEl] = React.useState(null);

  // This directs the calendar popper to where it should be,
  // Not the most elegant solution...
  React.useEffect(() => {
    if (containerRef?.current) {
      if (anchorEl === null && selectedPicker === "calendar") {
        setAnchorEl(containerRef.current);
      }
    }
  }, [containerRef, anchorEl, selectedPicker]);

  const handleDateChange = (newValue) => {
    const duration = 4;
    const endDate = new Date(
      add(newValue[0], { days: duration }).setHours(12, 0, 0)
    );
    const startDate = new Date(newValue[0].setHours(12, 0, 0));

    setSelectedDateRange([startDate, endDate]);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <DateRangePicker
        disableMaskedInput
        shouldDisableDate={isDisabled}
        disablePast
        calendars={mobileViewPort ? 1 : 2}
        displayStaticWrapperAs="desktop"
        value={selectedDateRange}
        onChange={(newValue) => {
          handleDateChange(newValue);
        }}
        PaperProps={{ style: { borderRadius: "14px", marginTop: "5px" } }}
        renderInput={(params) => {
          const customProps = {
            ...params,

            focused: selectedPicker === "calendar" ? true : false,
          };

          return (
            <Box
              onClick={() => setSelectedPicker("calendar")}
              sx={{ display: "flex", width: "100%" }}
            >
              <DatePickerDateInput
                contentHeigth={contentHeigth}
                id={"fixed-duration-picker"}
                pickerProps={customProps}
                selectedPicker={selectedPicker}
                setSelectedPicker={setSelectedPicker}
              />
            </Box>
          );
        }}
      />
    </Box>
  );
}
